import { render, staticRenderFns } from "./Testing2Sub.vue?vue&type=template&id=4f7d3948&scoped=true&"
import script from "./Testing2Sub.vue?vue&type=script&lang=js&"
export * from "./Testing2Sub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d3948",
  null
  
)

export default component.exports